import React from 'react';
import { trackAddToCart } from '../utils/metaPixel';
export function OrderBumpSection() {
  const handleClick = () => {
    trackAddToCart();
    window.location.href = 'https://dogcalm-es.myshopify.com/cart/53346665300305:1';
  };
  return <section className="pt-8 pb-12 px-5" data-id="element-205">
      <div className="max-w-lg mx-auto" data-id="element-206">
        <div className="rounded-2xl border-2 border-dashed overflow-hidden p-6 flex flex-col items-center text-center gap-4" style={{
        borderColor: '#D4AF37',
        backgroundColor: '#FFFBEB'
      }} data-id="element-207">
          <h3 className="text-lg font-extrabold text-charcoal leading-tight" data-id="element-208">
            🎁 AÑADE EL CÓDIGO DEL SILENCIO — Solo 4,90€
          </h3>

          <p className="text-charcoal/70 text-[15px] leading-relaxed" data-id="element-209">
            Tu perro aprende a estar solo sin destrozos ni ladridos.
          </p>

          <button onClick={handleClick} className="w-full text-white font-bold text-base py-4 rounded-full shadow-[0_4px_20px_rgba(34,197,94,0.35)] flex items-center justify-center gap-2 transition-all active:scale-[0.98]" style={{
          backgroundColor: '#22C55E'
        }} data-id="element-210">
            ✅ SÍ, LO QUIERO (+4,90€)
          </button>
        </div>
      </div>
    </section>;
}